// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xc33_","textarea":"styles_textarea__1c3gc"};